import { errorTypes, inputTypes } from "../types";
export const defaultErrorMessages = {
  [errorTypes.required]: __('Required field', [], {
    application_name: 'common_ui',
    namespace: 'common_field_errors'
  }),
  [errorTypes.invalid](_ref) {
    let {
      inputType
    } = _ref;
    switch (inputType) {
      case inputTypes.name:
        return __('Name must be at least 2 characters', [], {
          application_name: 'common_ui',
          namespace: 'common_field_errors'
        });
      case inputTypes.date:
        return __('Please enter a valid date', [], {
          application_name: 'common_ui',
          namespace: 'common_field_errors'
        });
      case inputTypes.time:
        return __('Invalid time', [], {
          application_name: 'common_ui',
          namespace: 'common_field_errors'
        });
      case inputTypes.expiration:
        return __('Invalid exp date', [], {
          application_name: 'common_ui',
          namespace: 'common_field_errors'
        });
      case inputTypes.cvv:
        return __('Invalid security code', [], {
          application_name: 'common_ui',
          namespace: 'common_field_errors'
        });
      case inputTypes.email:
        return __('Please enter a valid email', [], {
          application_name: 'common_ui',
          namespace: 'common_field_errors'
        });
      case inputTypes.color:
        return __('Please enter a valid color', [], {
          application_name: 'common_ui',
          namespace: 'common_field_errors'
        });
      case inputTypes.number:
        return __('Please enter a valid number', [], {
          application_name: 'common_ui',
          namespace: 'common_field_errors'
        });
      case inputTypes.phone:
        return __('Please enter a valid phone number', [], {
          application_name: 'common_ui',
          namespace: 'common_field_errors'
        });
      case inputTypes.routingNumber:
        return __('Please enter a valid routing number', [], {
          application_name: 'common_ui',
          namespace: 'common_field_errors'
        });
      case inputTypes.ssn:
        return __('Please enter a valid ssn', [], {
          application_name: 'common_ui',
          namespace: 'common_field_errors'
        });
      case inputTypes.url:
        return __('Please enter a valid url', [], {
          application_name: 'common_ui',
          namespace: 'common_field_errors'
        });
      case inputTypes.zip:
        return __('Please enter a valid zip code', [], {
          application_name: 'common_ui',
          namespace: 'common_field_errors'
        });
      default:
        return __('Invalid input', [], {
          application_name: 'common_ui',
          namespace: 'common_field_errors'
        });
    }
  },
  [errorTypes.minDate]: _ref2 => {
    let {
      minDate
    } = _ref2;
    return __('Date cannot be before {%t, 0, DATE_ALPHA_SHORT}', [minDate], {
      application_name: 'common_ui',
      namespace: 'common_field_errors'
    });
  },
  [errorTypes.maxDate]: _ref3 => {
    let {
      maxDate
    } = _ref3;
    return __('Date cannot be after {%t, 0, DATE_ALPHA_SHORT}', [maxDate], {
      application_name: 'common_ui',
      namespace: 'common_field_errors'
    });
  },
  [errorTypes.blackoutDate]: __('Date is unavailable', [], {
    application_name: 'common_ui',
    namespace: 'common_field_errors'
  }),
  [errorTypes.dateRangeOrder]: __('Start date cannot be after end date'),
  [errorTypes.minNumber]: _ref4 => {
    let {
      minValue
    } = _ref4;
    return __('Value must be greater than or equal to {%d, 0, nots}', [minValue], {
      application_name: 'common_ui',
      namespace: 'common_field_errors'
    });
  },
  [errorTypes.maxNumber]: _ref5 => {
    let {
      maxValue
    } = _ref5;
    return __('Value must be less than or equal to {%d, 0, nots}', [maxValue], {
      application_name: 'common_ui',
      namespace: 'common_field_errors'
    });
  },
  [errorTypes.minItems]: _ref6 => {
    let {
      minItems = 1
    } = _ref6;
    return __('Must enter at least {%p, 0, =0{0 items} =1{1 item} other{# items}}', [minItems], {
      application_name: 'common_ui',
      namespace: 'common_field_errors'
    });
  },
  [errorTypes.maxItems]: _ref7 => {
    let {
      maxItems
    } = _ref7;
    return __('Cannot enter more than {%p, 0, =0{0 items} =1{1 item} other{# items}}', [maxItems], {
      application_name: 'common_ui',
      namespace: 'common_field_errors'
    });
  }
};